import { ObservableValueProducerBase } from "./ChainableValueProducer";

export class FixedDirectoryEntriesProducer extends ObservableValueProducerBase<string[]> {
    private readonly directories: string[];

    public constructor(directories: string[]) {
        super();
        this.directories = directories;
    }

    // eslint-disable-next-line no-empty-function
    protected async beginListening(): Promise<void> {}

    // eslint-disable-next-line no-empty-function
    protected async stopListening(): Promise<void> {}

    protected async getCurrentValue(): Promise<string[]> {
        return this.directories;
    }
}
